import { render } from "./SocialsComponent.vue?vue&type=template&id=7b0ce909&scoped=true"
import script from "./SocialsComponent.vue?vue&type=script&lang=js"
export * from "./SocialsComponent.vue?vue&type=script&lang=js"

import "./SocialsComponent.vue?vue&type=style&index=0&id=7b0ce909&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0ce909"]])

export default __exports__